import { CONTACT } from '../features/landing/SiteChrome';
import { PolicyLayout } from '../features/landing/PolicyLayout';
import { POLICIES_UPDATED } from './Privacy';

export function Guidelines() {
  return (
    <PolicyLayout
      title="Community guidelines"
      updated={POLICIES_UPDATED}
      intro={<p>Roadrunner works because it’s made of neighbors. A few simple guidelines keep it that way.</p>}
    >
      <h2>Be a good neighbor</h2>
      <p>
        Be kind, assume good intentions, and disagree without insults. Write the way you’d talk to someone at the
        mailboxes.
      </p>

      <h2>Use your real name</h2>
      <p>Your first name and last initial is plenty. Neighbors should know who they’re talking to.</p>

      <h2>Keep it local</h2>
      <p>
        Post about things that matter close to home: lost pets, road work, outages, recommendations, questions, events
        down the street. National politics and news from across the country belong somewhere else.
      </p>

      <h2>Keep it accurate</h2>
      <p>
        Share what you know, and say so when you’re not sure. Don’t pass along rumors as facts, especially in alerts.
      </p>

      <h2>Respect people’s privacy</h2>
      <ul>
        <li>
          Don’t post other people’s addresses, phone numbers, license plates, or photos of people who can be recognized,
          without their permission.
        </li>
        <li>Don’t accuse a named or recognizable person of a crime. If something’s wrong, call the authorities.</li>
        <li>
          Everything you post is seen by your whole board, so think twice before sharing your own contact details.
        </li>
      </ul>

      <h2>No harassment, hate or threats</h2>
      <p>
        No harassing, bullying, threatening, or demeaning anyone, including for their race, ethnicity, religion, gender,
        sexual orientation, disability or age. This is the one rule with no second chances.
      </p>

      <h2>No spam or selling</h2>
      <p>
        Roadrunner isn’t a marketplace. Recommending a business you’ve used is great. Promoting your own business over
        and over isn’t. An occasional “free to a good home” note is fine.
      </p>

      <h2>In an emergency, call 911</h2>
      <p>Roadrunner isn’t watched around the clock. Post alerts for neighbors, but call for help first.</p>

      <h2>How moderation works</h2>
      <ul>
        <li>Anyone can report a note, reply or profile from its menu. Reports are private.</li>
        <li>
          Local moderators review reports. Depending on what they find, they may leave it be, remove the post, suspend
          the account for a while (you can still read, but not post), or ban it.
        </li>
        <li>Every moderation decision is recorded, so decisions stay consistent and accountable.</li>
        <li>
          Think a decision was wrong? <a href={`mailto:${CONTACT.email}`}>Email me</a> and I’ll take another look.
        </li>
      </ul>
    </PolicyLayout>
  );
}
